import { useState } from 'react';
import { useSurveyContext } from '../../context/SurveyContext';

export const SUBMIT_ERROR_MESSAGE =
  "We couldn't send your report just now. Please check your connection and try again.";

/**
 * Wraps submitSurvey with the in-flight and error state the survey screens need,
 * and moves to the completion screen once the backend accepts the answers.
 *
 * Shared by the two section breaks ("Send Report to Email") and the final
 * end-of-Section-3 submit so all three behave the same way on failure.
 */
export const useSurveySubmit = () => {
  const { submitSurvey, setCurrentStep } = useSurveyContext();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const submit = async (answers: Record<string, unknown>): Promise<boolean> => {
    setIsSubmitting(true);
    setError(null);

    const result = await submitSurvey(answers);

    if (result.success) {
      // Leave isSubmitting set: this screen is replaced by the end screen.
      window.scrollTo({ top: 0, behavior: 'smooth' });
      setCurrentStep('end');
      return true;
    }

    console.error('Failed to submit survey:', result.error);
    setError(SUBMIT_ERROR_MESSAGE);
    setIsSubmitting(false);
    return false;
  };

  return { submit, isSubmitting, error, setError };
};
